import React from "react";
import RolePermissionListItem from "../../components/rolePermission/RolePermissionList/RolePermissionListItem";
import {Box} from "@mui/material";
import {useParams} from "react-router";
import {useTitle} from 'react-use';
import { t } from "@lingui/core/macro";

const RolePermissionListPage = ()  => {

    useTitle(t`List Role Permission`);
    
    const allQueries = useParams()
    const query = Object.fromEntries(
        Object.entries(allQueries).filter(([key]) => key.endsWith("Id"))
    )
    
    return (
        <Box>
            <RolePermissionListItem showAdd={true} {...query} />
        </Box>
    )
}

export default RolePermissionListPage;
